import { Card, Row, Col, Typography, Form, Input, Button } from "antd";

export const ConcessionsForm = ({ form, editMode }: any) => {
  return (
    <Card
      style={{
        borderRadius: "8px",
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
        marginBottom: 16,
      }}
      title={
        <Typography.Title level={4}>
          Concessions and Other Obligations/Conditions
        </Typography.Title>
      }
    >
      <Row gutter={[16, 16]}>
        <Col xs={24} md={12}>
          <Typography.Title level={5}>Concessions (Max 4)</Typography.Title>
          <Form.List name="concessions">
            {(fields, { add, remove }) => (
              <>
                {fields.map((field, index) => (
                  <div key={field.key} style={{ marginBottom: 16 }}>
                    <Row
                      justify="space-between"
                      align="middle"
                      style={{ marginBottom: 8 }}
                    >
                      <Col>
                        <Typography.Text strong>{`Concession ${
                          index + 1
                        }`}</Typography.Text>
                      </Col>
                      <Col>
                        <Button
                          danger
                          type="link"
                          onClick={() => remove(field.name)}
                          disabled={!editMode}
                        >
                          Remove
                        </Button>
                      </Col>
                    </Row>
                    <Form.Item
                      {...field}
                      noStyle
                      rules={[
                        { required: true, message: "Enter concession text" },
                      ]}
                    >
                      <Input placeholder="Enter concession text (one-liner)" />
                    </Form.Item>
                  </div>
                ))}
                {fields.length < 4 && (
                  <Button
                    type="dashed"
                    onClick={() => add("")}
                    block
                    disabled={!editMode}
                  >
                    Add Concession
                  </Button>
                )}
              </>
            )}
          </Form.List>
        </Col>
        <Col xs={24} md={12}>
          <Typography.Title level={5}>
            Other Obligations/Conditions (Max 4)
          </Typography.Title>
          <Form.List name="conditions">
            {(fields, { add, remove }) => (
              <>
                {fields.map((field, index) => (
                  <div key={field.key} style={{ marginBottom: 16 }}>
                    <Row
                      justify="space-between"
                      align="middle"
                      style={{ marginBottom: 8 }}
                    >
                      <Col>
                        <Typography.Text strong>{`Condition ${
                          index + 1
                        }`}</Typography.Text>
                      </Col>
                      <Col>
                        <Button
                          danger
                          type="link"
                          onClick={() => remove(field.name)}
                          disabled={!editMode}
                        >
                          Remove
                        </Button>
                      </Col>
                    </Row>
                    <Form.Item
                      {...field}
                      noStyle
                      rules={[
                        { required: true, message: "Enter condition text" },
                      ]}
                    >
                      <Input placeholder="Enter condition text (one-liner)" />
                    </Form.Item>
                  </div>
                ))}
                {fields.length < 4 && (
                  <Button
                    type="dashed"
                    onClick={() => add("")}
                    block
                    disabled={!editMode}
                  >
                    Add Condition
                  </Button>
                )}
              </>
            )}
          </Form.List>
        </Col>
      </Row>
    </Card>
  );
};
